import { QueryKeys } from "./query-client";
import { useQuery } from "react-query";
import { PickerData, Schedule } from "../../constants/model/models";
import { useJWT } from "./useJWT";
import { BACKEND_URL, localServerUrl } from "../../constants/env";
import { useTranslation } from "next-i18next";

export function useScheduleList() {
  const { jwt } = useJWT();
  const { i18n } = useTranslation("common");
  // const {} =
  const {
    data: schedules,
    isFetching: schedulesAreLoading,
    isError: schedulesError,
  } = useQuery([QueryKeys.SCHEDULES], () => getSchedules(), {
    enabled: typeof jwt !== "undefined" && typeof jwt !== null,
    keepPreviousData: true,
    retry: 2,
    refetchOnMount: true,
    refetchOnReconnect: true,
    refetchOnWindowFocus: true,
  });

  function returnSpecialtyOptions(schedules: Schedule[]): PickerData[] {
    const specialtyData: PickerData[] = [];

    schedules.map((schedule) => {
      if (schedule.scheduleCategories.length > 0) {
        schedule.scheduleCategories.map((scheduleCategory) =>
          extractCategories(scheduleCategory.category, specialtyData)
        );
      } else {
        extractCategories(schedule.scheduleCategory, specialtyData);
      }
    });

    return specialtyData;
  }
  function extractCategories(
    scheduleCategory: string,
    specialtyData: PickerData[]
  ) {
    const data: PickerData = {
      value: scheduleCategory,
      label: scheduleCategory,
    };
    const isElementPresent = specialtyData.some(
      (o) => o.value.toString() === data.value.toString()
    );
    if (!isElementPresent) {
      specialtyData.push(data);
    }
  }

  function extractedSpecialist(
    schedule: Schedule,
    specialistData: PickerData[]
  ) {
    const data: PickerData = {
      value: schedule.id.toString(),
      label: schedule.name,
    };
    specialistData.push(data);
  }

  function returnSpecialistOptions(
    schedules: Schedule[],
    scheduleCategory: string
  ): PickerData[] {
    const specialistData: PickerData[] = [];
    schedules
      .sort((a, b) => a.name.localeCompare(b.name))
      .map((schedule) => {
        extractedSpecialist(schedule, specialistData);
        // if (schedule.scheduleCategories.length > 0) {
        //   schedule.scheduleCategories.map((category) => {
        //     if (
        //       category.category.toLowerCase() === scheduleCategory.toLowerCase()
        //     ) {
        //       extractedSpecialist(schedule, specialistData);
        //     }
        //   });
        // } else {
        //   if (
        //     schedule.scheduleCategory.toString() === scheduleCategory.toString()
        //   ) {
        //     extractedSpecialist(schedule, specialistData);
        //   }
        // }
      });

    return specialistData;
  }

  function returnServiceOptions(
    schedules: Schedule[],
    specialist: Schedule
  ): PickerData[] {
    const servicesData: PickerData[] = [];
    if (schedules && schedules.length > 0) {
      const schedule = returnFilteredSpecialist(specialist.id, schedules);
      if (schedule) {
        schedule.services.map((service) => {
          const data: PickerData = {
            value: service.service,
            label: `${service.service} (${timeConvert(+service.duration)})`,
          };
          servicesData.push(data);
        });
      }
    }
    return servicesData;
  }

  function returnFilteredSpecialist(
    scheduleId: number,
    schedules: Schedule[]
  ): Schedule | undefined {
    return schedules.find(
      (item) =>
        item.id.toString().toLowerCase() === scheduleId.toString().toLowerCase()
    );
  }

  async function getSchedules(): Promise<Schedule[] | undefined> {
    const response = await fetch(`${BACKEND_URL}/schedule`, {
      // @ts-ignore, will only run on defined jwt
      headers: {
        "Content-type": "application/json",
        accessToken: jwt,
        "Access-Control-Allow-Origin": localServerUrl,
      },
    });

    return await response.json();
  }

  function timeConvert(n: number) {
    const num = n;
    const hours = num / 60;
    const rhours = Math.floor(hours);
    const minutes = (hours - rhours) * 60;
    const rminutes = Math.round(minutes);
    let addZerotoMinutes;
    if (rminutes < 9) {
      addZerotoMinutes = "0" + rminutes;
    } else {
      addZerotoMinutes = rminutes;
    }

    let minString = " min";
    if (i18n.language.includes("ru")) minString = " мин";
    let hourString = " h";
    if (i18n.language.includes("ru")) hourString = " ч";
    let longHourString = " h ";
    if (i18n.language.includes("ru")) longHourString = " ч ";

    if (rminutes > 0) {
      if (rhours > 0) {
        return rhours + longHourString + addZerotoMinutes + minString;
      } else {
        return addZerotoMinutes + minString;
      }
    } else {
      return rhours + hourString;
    }
  }

  return {
    schedules,
    schedulesAreLoading,
    schedulesError,
    returnSpecialtyOptions,
    returnSpecialistOptions,
    returnServiceOptions,
    returnFilteredSpecialist,
  };
}
